export default __webpack_public_path__ + "static/media/Lisbon.70a170be.jpeg";